import React from 'react'

const NotFound = () => {
  return (
    <div className='not-found'>
    <img src="https://www.pngitem.com/pimgs/m/255-2550411_404-error-images-free-png-transparent-png.png" alt="not-found" className='w-100' />
      
    </div>
  )
}

export default NotFound
